import { graphql } from '../gql';
import { useQuery } from '@apollo/client';
import { GetInsuredPoliciesQueryVariables } from '../gql/graphql';

export const GET_INSURED_POLICIES = graphql(`
  query getInsuredPolicies(
    $pagination: PaginationRequest
    $filters: PolicyFilterInput
    $sort: PaginationSort
  ) {
    policies(pagination: $pagination, filters: $filters, sort: $sort) {
      pageInfo {
        totalResults
        pageNumber
        pageSize
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          uuid
          type
          status
          referenceId
          brokerCommissionAmount
          stateTax
          policyFee
          stampingFee
          boundPremium
          grossPremium
          netPremium
          startDate
          endDate
          transactionDate
          createdAt
          updatedAt
          insuredName
          documentLink
          isActive
          showCancellationModal
          quoteLimit
          quoteRetention
          broker {
            uuid
            firstName
            lastName
            uuid
          }
          midtermTransactions {
            edges {
              node {
                uuid
                type
                subType
                refundType
                effectiveDate
                grossAnnualPremium
                refundAmount
                additionalPremium
                createdAt
                updatedAt
                createdBy
                status
                mttPolicyExtensionDate
                mttErpYears
                notes {
                  edges {
                    node {
                      createdAt
                      label
                      note
                      targetName
                      targetSubName
                      targetSubUuid
                      targetType
                      targetUuid
                      tenant
                      updatedAt
                      user {
                        cursor
                        node {
                          firstName
                          lastName
                          username
                        }
                        queryCursor
                      }
                      uuid
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`);

export function useInsuredPoliciesQuery(
  variables: GetInsuredPoliciesQueryVariables
) {
  const { loading, error, data } = useQuery(GET_INSURED_POLICIES, {
    variables,
  });

  return {
    loading,
    error,
    data,
  };
}
